import React, { Component } from 'react';

import OrganizationApi from '../../api/organization';
import Button from '../form/Button';
import Message from '../form/Message';
import TemplateApi from '../../api/template';

import { history } from '../../state/store';
import Checkbox from '../form/Checkbox';

class OrganizationDetails extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            errorMessage: null,
            infoMessage: null,
            deleteErrors: null,
            isbusy: false,
            isdeleting: false,
            name: '',
            abbreviation: '',
            is_archived: false,
        };

        this.deleteOrganization = this.deleteOrganization.bind(this);
        this.onChange = this.onChange.bind(this);
        this.saveOrganization = this.saveOrganization.bind(this);
    }

    async componentDidMount() {
        // Fetch the ids of the NYS and default templates.
        try {
            const nysId = await TemplateApi.getTemplateIdByName(
                'PCMH_NYS_2019'
            );
            const defaultId = await TemplateApi.getTemplateIdByName('PCMH2018');

            this.setState({
                defaultTemplateId: defaultId,
                nysTemplateId: nysId,
            });
        } catch (error) {
            console.log(error);
        }
    }

    componentWillReceiveProps(nextProps) {
        const current = this.props.organization;
        const next = nextProps.organization;
        if (next && (!current || next.id !== current.id)) {
            this.setState({
                name: next.name,
                abbreviation: next.abbreviation || '',
                errorMessage: null,
                infoMessage: null,
                deleteErrors: null,
                isbusy: false,
                isdeleting: false,
                is_archived: next.is_archived || false,
            });
        }
    }

    deleteOrganization() {
        if (
            window.confirm(
                'WARNING!\n\nDeleting an Organization is a permanent, non-recoverable action.\n\nAre you sure you want to permanently delete this Organization and all associated data?'
            )
        ) {
            this.setState({ isdeleting: true, deleteErrors: null }, () => {
                OrganizationApi.delete(this.props.organization.id)
                    .then(() => {
                        this.setState({ isdeleting: false });
                        this.props.onDelete();
                    })
                    .catch((err) => {
                        this.setState({
                            isdeleting: false,
                            deleteErrors: 'Error deleting organization.',
                        });
                    });
            });
        }
    }

    saveOrganization() {
        const changes = {
            name: this.state.name,
            abbreviation: this.state.abbreviation || '',
            is_archived: this.state.is_archived || false,
        };
        this.setState(
            { errorMessage: null, infoMessage: null, isbusy: true },
            () => {
                OrganizationApi.update(this.props.organization.id, changes)
                    .then(() => {
                        this.setState({
                            isbusy: false,
                            infoMessage: 'Changes saved.',
                        });
                        this.props.onUpdate(
                            Object.assign({}, this.props.organization, changes)
                        );
                    })
                    .catch((errorMessage) => {
                        this.setState({ errorMessage: errorMessage });
                    });
            }
        );
    }

    onChange(evt) {
        let changes = {};
        changes[evt.target.name] = evt.target.value;
        this.setState(changes);
    }

    render() {
        const org = this.props.organization;

        if (!org) {
            return <div className="ManagePage__details" />;
        }

        return (
            <div className="ManagePage__details">
                <form onSubmit={this.onFormSubmit}>
                    <div className="form__field">
                        <label htmlFor="name">Name</label>
                        <input
                            type="text"
                            name="name"
                            value={this.state.name}
                            onChange={this.onChange}
                        />
                    </div>

                    <div className="form__field">
                        <label htmlFor="name">Abbreviation</label>
                        <input
                            type="text"
                            name="abbreviation"
                            value={this.state.abbreviation}
                            onChange={this.onChange}
                        />
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="form__field">
                                <Checkbox
                                    label={`Archive ${this.state.name}`}
                                    defaultChecked={this.state.is_archived}
                                    onChange={(value) =>
                                        this.setState({ is_archived: value })
                                    }
                                />
                            </div>
                        </div>
                    </div>

                    {/* <div className="row">
                        <div className="column">
                            <div className="form__field">
                                <Checkbox
                                    label="NYS Required Criteria"
                                    defaultChecked={this.state.use_nys}
                                    disabled={this.state.orgHasPractices}
                                    onChange={value =>
                                        this.setState({ use_nys: value })
                                    }
                                />
                                {this.state.orgHasPractices && (
                                    <p>
                                        Practices exist for this Organization
                                        and this selection is no longer
                                        editable.
                                    </p>
                                )}
                            </div>
                        </div>
                    </div> */}
                    <div className="form__footer">
                        <Message
                            info={this.state.infoMessage}
                            error={this.state.errorMessage}
                        />
                    </div>

                    <div className="form__buttons">
                        <Button
                            icon="fa-save"
                            defaultText="Save Updates"
                            busyText="Saving Updates..."
                            isbusy={this.state.isbusy}
                            onClick={this.saveOrganization}
                        />
                    </div>
                </form>

                <hr />
                <div className="align-center">
                    <Button
                        size="small"
                        icon="fa-sitemap"
                        defaultText={`View ${org.name} Dashboard`}
                        onClick={() => {
                            history.push(`/organization/${org.id}`);
                        }}
                    />
                </div>

                <hr />

                <h5>Danger Zone</h5>
                <p>
                    If you would like to delete this organization from your
                    account, you can do so by clicking the button below. This
                    will remove all practices, progress, and documents
                    associated with this organization.
                </p>
                <Button
                    size="small"
                    danger="true"
                    icon="fa-trash"
                    defaultText="Delete Organization"
                    busyText="Deleting Organization..."
                    isbusy={this.state.isdeleting}
                    onClick={this.deleteOrganization}
                />
            </div>
        );
    }
}

export default OrganizationDetails;
